import { render, staticRenderFns } from "./MeetingFooter.vue?vue&type=template&id=20ae7534&scoped=true"
import script from "./MeetingFooter.vue?vue&type=script&setup=true&lang=ts"
export * from "./MeetingFooter.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./MeetingFooter.vue?vue&type=style&index=0&id=20ae7534&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20ae7534",
  null
  
)

export default component.exports